<template>
  <div class="error-content">
    <div v-if="invalidState == 'PAID'" class="flex-column align-center">
      <div class="info-paid-circle">
        <check-circle-icon size="2.0x" class="info-paid small-buffer" />
      </div>
      <h2 class="small-buffer">Thank You!</h2>
      <p>
        This request for payment has already been paid. Please contact the
        practice for more information
      </p>
    </div>
    <div
      v-else-if="invalidState == 'CANCELLED'"
      class="flex-column align-center"
    >
      <div class="info-cancelled-circle">
        <alert-triangle-icon size="2.0x" class="info-cancelled small-buffer" />
      </div>
      <h2 class="small-buffer">Oops!</h2>
      <p>
        This request for payment has been cancelled by the practice. We
        apologize for the inconvience.
      </p>
    </div>
    <div v-else class="flex-column align-center">
      <div class="info-cancelled-circle">
        <alert-triangle-icon size="2.0x" class="info-cancelled small-buffer" />
      </div>
      <h2 class="small-buffer">Oops!</h2>
      <p>
        This request for payment has encountered an error. Please contact the
        practice. We apologize for the inconvience.
      </p>
    </div>
  </div>
</template>

<script>
  import { AlertTriangleIcon, CheckCircleIcon } from "vue-feather-icons";

  export default {
    name: "UpdoxPaymentInvalidState",
    components: { AlertTriangleIcon, CheckCircleIcon },
    props: {
      errorDetails: {
        type: Object,
        required: false,
      },
      invalidState: {
        type: String,
        required: false,
      },
    },
    computed: {
      error: function () {
        return console.error("UpdoxPaymentInvalidState called");
      },
    },
    methods: {},
  };
</script>
<style lang="scss">
  .error-content {
    background-color: #fff;
    padding: 15px;
    margin-top: 20px;
  }

  @mixin faux-circle {
    width: 48px;
    height: 48px;
    border-radius: 24px;
    padding: 10px;
  }

  .info-paid {
    color: rgb(110, 176, 38);
  }
  .info-paid-circle {
    @include faux-circle;
    background-color: rgba(110, 176, 38, 0.2);
  }

  .info-cancelled {
    color: rgb(248, 148, 32);
    margin-top: -2px;
  }
  .info-cancelled-circle {
    @include faux-circle;
    background-color: rgba(248, 148, 32, 0.2);
  }

  .small-buffer {
    margin-bottom: 5px;
  }
</style>
